import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState(null);
  const [modalProps, setModalProps] = useState({});

  const handleGlobalModalState = modalData => {
    setModalState(modalData);
  };

  const openModal = useCallback((type, props = {}) => {
    setModalState(type);
    setModalProps(props);
  }, []);

  const closeModal = useCallback(() => {
    setModalState(null);
    setModalProps({});
  }, []);

  return (
    <ModalContext.Provider
      value={{
        modalState,
        modalProps,
        openModal,
        closeModal,
        handleGlobalModalState,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node,
};

export const useModal = () => useContext(ModalContext);
